import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import AccountRepository from '@/shared/http/repositories/access/account'
import CoordinatorRepository from '@/shared/http/repositories/configuration/coordinator'
import CoordinatorModel from '@/shared/models/configuration/coordinatormodel'
import CoordinatorForms from './coordinator-form'

export default {
  name: 'Branch',
  mixins: [ActionsForm],
  data () {
    return {
      data: CoordinatorModel,
      form: CoordinatorForms,
      contas: null
    }
  },
  watch: {
    'form.contaID.value': function (value) {
      if (value !== null && this.contas) {
        let obj = this.contas.find(x => x.id === value)
        this.form.email.value = obj.email
      } else {
        this.form.email.value = null
      }
    }
  },
  created () {
    this.onLoadAllSections()
    this.onLoadAllContas()
  },
  methods: {
    onLoad () {
      loading.push()
      CoordinatorRepository.GetAllPaging(this.CompanySelected, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      CoordinatorRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      this.data.status = parseInt(this.data.status)
      CoordinatorRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      CoordinatorRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.secaoRHID.options = this.onResultDropdown(response, null, f => f.codigo + ' - ' + f.nome)
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllContas () {
      loading.push()
      AccountRepository.GetAll(this.CompanySelected)
        .then((response) => {
          if (response.data.code > 0) {
            this.contas = response.data.data
            this.form.contaID.options = this.onResultDropdown(response, null, f => f.nome)
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/coordinator/coordinator.js